import { SiteURL } from '../../constants';

// The public origin of the site. Kept in step with `siteUrl` in next-sitemap.config.js.
const ProductionOrigin = 'https://www.gaspar.ai';

/**
 * SITE_URL cannot be trusted to hold the public origin: publicRuntimeConfig is resolved when the
 * image is built, the committed .env.local sets SITE_URL to localhost, and the runtime SITE_URL
 * from the Dockerfile never reaches the app because next.config.js is not copied into the final
 * stage. Emitting that value into a canonical tag would point every page at localhost, so the
 * configured value is only honoured when it is a real public origin.
 */
const getOrigin = () => {
  const configured = String(SiteURL || '')
    .trim()
    .replace(/\/+$/, '');
  const isPublicOrigin = /^https:\/\//i.test(configured) && !/^https:\/\/(localhost|127\.0\.0\.1)/i.test(configured);
  return isPublicOrigin ? configured : ProductionOrigin;
};

// Converts an app relative path (eg. /blog/my-post) into a fully qualified URL.
// Canonical tags, og:url and JSON-LD are all required to be absolute.
export const toAbsoluteUrl = (path?: string) => {
  const origin = getOrigin();
  if (!path) {
    return origin;
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
};
